import React from 'react';
import PropTypes from 'prop-types';

import ItemWithImage from '../../../02_molecules/Item/ItemWithImage';
import { PTItemWithImage } from '../../../02_molecules/Item/ItemWithImage/prop-types';

import styles from './index.module.scss';

const BBCountryList = ({ title = '', items }) => (
  <div className={`bb bb-country-listing ${styles['bb-country-listing']}`}>
    <div className="container">
      {title && <h2 className="rockitt">{title}</h2>}

      <div className="row">
        {items.map((item) => (
          <div className="col-6 col-md-4 col-lg-3" key={item.title}>
            <ItemWithImage
              isGradientOnImage
              isDesktopTitleOverlaysImage
              isMobileTitleOverlaysImage
              {...item}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

BBCountryList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(PTItemWithImage)).isRequired,
};

export default BBCountryList;
